// Scale iframe to prevent viewport overflow
export function iframeScale() {
  if (document.querySelector(".m-iframe")) {
    var iframe = document.querySelector(".m-iframe iframe");
    var container = document.querySelector(".m-iframe .container");

    if (iframe && container) {
      var iframeWidth = iframe.offsetWidth;
      var iframeHeight = iframe.offsetHeight;
      var containerWidth = container.offsetWidth;

      var containerStyles = window.getComputedStyle(container);
      var containerPaddingLeft = parseFloat(containerStyles.paddingLeft);
      var containerPaddingRight = parseFloat(containerStyles.paddingRight);

      var containerEffectiveWidth =
        containerWidth - containerPaddingLeft - containerPaddingRight;

      if (iframeWidth > containerEffectiveWidth) {
        var scaleRatio = containerEffectiveWidth / iframeWidth;
        iframe.style.transform =
          "translate(-50%, -50%) scale(" + scaleRatio + ")";
        container.style.height = iframeHeight * scaleRatio + "px";
      } else {
        /* iframe.style.transform = "translate(-50%, -50%) scale(1)";
        container.style.height = iframeHeight + "px"; */
      }
    }
  }
}
